module.exports = __webpack_public_path__ + "img/taib3.38cd1666.png";